export default __webpack_public_path__ + "static/media/site-about.d1702178.svg";